import { Channel } from '@monofront/business/constants';
import { IWishlistCRUD, ProductService } from '@monofront/business/services';
import { IWishlist } from '@monofront/types';
import {
  collection,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  onSnapshot,
} from '@firebase/firestore';
import firebaseService from '../firebase';

export class WishlistCRUD implements IWishlistCRUD {
  private productService: ProductService;

  constructor(productService: ProductService) {
    this.productService = productService;
  }

  private getUrl = (customerUid: string) =>
    `customers/${customerUid}/wishlists`;

  public async create(customerUid: string, data: Record<string, any>) {
    const collectionRef = collection(
      firebaseService.db,
      this.getUrl(customerUid),
    );

    return await addDoc(collectionRef, data);
  }

  public async update(
    customerUid: string,
    wishlistUid: string,
    data: Record<string, any>,
  ) {
    const docRef = doc(
      firebaseService.db,
      this.getUrl(customerUid),
      wishlistUid,
    );

    return await updateDoc(docRef, data);
  }

  public async delete(customerUid: string, wishlistUid: string) {
    const docRef = doc(
      firebaseService.db,
      this.getUrl(customerUid),
      wishlistUid,
    );

    return await deleteDoc(docRef);
  }

  public listen(
    customerUid: string,
    channel: Channel,
    callback: (wishlists: IWishlist[]) => void,
  ) {
    const collectionRef = collection(
      firebaseService.db,
      this.getUrl(customerUid),
    );

    return onSnapshot(collectionRef, async (response) => {
      if (response.docs) {
        const allDbWishlistsProducts = response.docs
          .map((doc) => doc.data().products)
          .flat(1);

        const algoliaProducts = await this.productService.getProductsBySku(
          allDbWishlistsProducts,
          channel,
        );

        const wishlists: IWishlist[] = response.docs.map((doc) => {
          const {
            name,
            products: firebaseProducts,
            defaultWishlist,
          } = doc.data();
          const products = algoliaProducts.filter(({ objectID }) =>
            firebaseProducts.find((id) => id === objectID),
          );

          const wishlist: IWishlist = {
            id: doc.id,
            name,
            products: products,
            defaultWishlist,
          };

          return wishlist;
        });

        callback(wishlists);
      }
    });
  }
}
